/**
 * Placement vocabulary shared by every anchored, top-layer surface (tooltips, menus).
 *
 * A placement is `<primary>` or `<primary>-<secondary>`:
 *
 * * `primary` (`top` | `bottom` | `left` | `right`) is the side of the anchor the surface sits on.
 * * `secondary` (`left` | `middle` | `right`) aligns the surface along the anchor's cross axis and
 *   only applies to `top`/`bottom` primaries. It defaults to `middle` when omitted.
 *
 * These previously lived in `constants/tooltip.js`, which still re-exports them for compatibility.
 */
export const BOTTOM = 'bottom';
export const LEFT = 'left';
export const RIGHT = 'right';
export const TOP = 'top';
export const MIDDLE = 'middle';
export const BOTTOM_LEFT = `${BOTTOM}-${LEFT}`;
export const BOTTOM_MIDDLE = `${BOTTOM}-${MIDDLE}`;
export const BOTTOM_RIGHT = `${BOTTOM}-${RIGHT}`;
export const TOP_LEFT = `${TOP}-${LEFT}`;
export const TOP_MIDDLE = `${TOP}-${MIDDLE}`;
export const TOP_RIGHT = `${TOP}-${RIGHT}`;
export const PLACEMENT_OPTIONS = [
  BOTTOM_LEFT,
  BOTTOM_MIDDLE,
  BOTTOM_RIGHT,
  LEFT,
  RIGHT,
  TOP_LEFT,
  TOP_MIDDLE,
  TOP_RIGHT,
];

/**
 * The subset whose primary axis is vertical: the surface sits above or below its anchor and aligns
 * along the anchor's horizontal edge.
 *
 * A surface restricts itself to this family when its size or its overflow handling assumes a
 * vertical relationship to the anchor. `Spds::Core::Menu::Base` is the case in point: it defaults
 * to the anchor's width, which only reads as a dropdown when it sits directly above or below, and
 * the horizontal cascade in `positioning.js` only corrects `top`/`bottom` primaries — a side
 * placement has no cross-axis correction, so a tall menu would hang off the viewport with no
 * recovery path.
 */
export const VERTICAL_PLACEMENT_OPTIONS = [
  BOTTOM_LEFT,
  BOTTOM_MIDDLE,
  BOTTOM_RIGHT,
  TOP_LEFT,
  TOP_MIDDLE,
  TOP_RIGHT,
];

export default {
  BOTTOM,
  LEFT,
  RIGHT,
  TOP,
  MIDDLE,
  BOTTOM_LEFT,
  BOTTOM_MIDDLE,
  BOTTOM_RIGHT,
  TOP_LEFT,
  TOP_MIDDLE,
  TOP_RIGHT,
  PLACEMENT_OPTIONS,
  VERTICAL_PLACEMENT_OPTIONS,
};
